export type TimezoneOption = {
  value: string;
  name: string;
};

export const timezones: TimezoneOption[] = [
  { value: "Pacific/Pago_Pago", name: "Samoa" },
  { value: "Pacific/Honolulu", name: "Hawaii" },
  { value: "America/Anchorage", name: "Alaska" },
  { value: "America/Los_Angeles", name: "Pacific Time" },
  { value: "America/Phoenix", name: "Arizona" },
  { value: "America/Denver", name: "Mountain Time" },
  { value: "America/Chicago", name: "Central Time" },
  { value: "America/New_York", name: "Eastern Time" },
  { value: "America/Halifax", name: "Atlantic Time" },
  { value: "America/Sao_Paulo", name: "Brasília Time" },
  { value: "America/Noronha", name: "Fernando de Noronha" },
  { value: "Atlantic/Azores", name: "Azores" },
  { value: "Africa/Abidjan", name: "GMT" },
  { value: "Europe/Paris", name: "Central European Time" },
  { value: "Europe/Athens", name: "Eastern European Time" },
  { value: "Europe/Moscow", name: "Moscow Time" },
  { value: "Asia/Tehran", name: "Iran Time" },
  { value: "Asia/Dubai", name: "Gulf Time" },
  { value: "Asia/Kabul", name: "Afghanistan Time" },
  { value: "Asia/Karachi", name: "Pakistan Time" },
  { value: "Asia/Kolkata", name: "India Time" },
  { value: "Asia/Kathmandu", name: "Nepal Time" },
  { value: "Asia/Dhaka", name: "Bangladesh Time" },
  { value: "Asia/Yangon", name: "Myanmar Time" },
  { value: "Asia/Bangkok", name: "Indochina Time" },
  { value: "Asia/Shanghai", name: "China Time" },
  { value: "Australia/Eucla", name: "Australian Central Western Time" },
  { value: "Asia/Tokyo", name: "Japan Time" },
  { value: "Australia/Adelaide", name: "Australian Central Time" },
  { value: "Australia/Sydney", name: "Australian Eastern Time" },
  { value: "Pacific/Noumea", name: "New Caledonia Time" },
  { value: "Pacific/Auckland", name: "New Zealand Time" },
  { value: "Pacific/Chatham", name: "Chatham Time" },
  { value: "Pacific/Tongatapu", name: "Tonga Time" },
  { value: "Pacific/Kiritimati", name: "Line Islands Time" },
];
